// extracted by mini-css-extract-plugin
export default {"card-container":"Card_card-container__cXkiR"};